import { useCallback, useEffect, useState } from "react";
import { healthProfileService } from "@/services/health-profile.service";
import {
  HealthProfileSummary,
  MedicalDetailType,
} from "@/types/health-profile";
import familyStatsService from "@/services/familyStats.service";

// Generic profile field hook for any profile field (e.g., allergies, bloodType, etc)
export const useProfileSummary = (memberId: string) => {
  const [summary, setSummary] = useState<HealthProfileSummary>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  const fetchProfile = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await healthProfileService.getProfileSummary(memberId);
      setSummary(result);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [memberId]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  const updateNone = async (type: MedicalDetailType) => {
    try {
      await healthProfileService.updateNone(memberId, type);
      fetchProfile();

      // Refetch family stats to update profile score/strength
      try {
        await familyStatsService.getFamilyStats();
      } catch (err) {
        console.error("Failed to refresh family stats:", err);
      }
    } catch (err) {
      setError(err);
    }
  };

  return {
    summary,
    loading,
    updateNone,
    error,
  };
};
